import {onFind} from "@elements/init-modules-in-scope";

import Modal from 'bootstrap.native/dist/components/modal-native.esm';
onFind('[data-toggle="modal"]',function (element) {
    new Modal(element);
});

import Tab from 'bootstrap.native/dist/components/tab-native.esm';
onFind('[data-toggle="tab"]',function (element) {
    new Tab(element);
});

import Collapse from 'bootstrap.native/dist/components/collapse-native.esm';
onFind('[data-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import './scripts/common';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as formValidation from './scripts/form-validation';
formValidation.init();

import * as friendlyCaptcha from './scripts/friendly-captcha';
friendlyCaptcha.init();

import * as actionChanger from '@elements/action-changer';
app.actionChanger = actionChanger.init();

import * as scrollingArea from './scripts/scrolling-area';
scrollingArea.init();

import * as lightbox from '@elements/lightbox';
app.lightbox = lightbox.init();

import * as interactiveSvg from './scripts/interactive-svg';
interactiveSvg.init();

import * as fetchModal from './scripts/fetch-modal';
fetchModal.init();

import * as checkAll from './scripts/check-all';
checkAll.init();

import * as datepicker from '@elements/datepicker';
datepicker.init();